import { Card } from "antd";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
const { Meta } = Card;

const CategoryFeatureCard = ({
  title,
  description,
  image,
  features = [],
  link,
  customClassName,
}) => (
  <Card
    key={title}
    hoverable
    className={`w-full max-w-md mx-auto shadow-lg rounded-2xl border border-gray-200 bg-white flex flex-col items-center transition-transform duration-300 hover:scale-105 ${customClassName}`}
    cover={
      <div className="overflow-hidden rounded-t-2xl relative group">
        <img
          alt={title}
          src={image}
          className="w-full h-72 object-contain p-4 bg-gray-50"
        />
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-300 flex justify-center items-center">
          <Link
            to={link}
            className="text-white text-lg font-semibold border-2 border-white rounded-full py-2 px-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          >
            Explore More
          </Link>
        </div>
      </div>
    }
  >
    <Meta
      title={
        <h3 className="text-center text-xl font-semibold text-gray-800 mt-2">
          {title}
        </h3>
      }
      description={
        <div className="text-center font-sans">
          <p className="text-base text-gray-600 mt-2 leading-relaxed">
            {description}
          </p>
          <ul className="mt-4 space-y-2 leading-relaxed list-none text-left mx-auto flex flex-col items-center">
            {features.map((feature, idx) => (
              <li
                key={idx}
                className="flex items-center text-gray-700 w-full max-w-xs"
              >
                <span className="flex-shrink-0 w-6 flex justify-center"><FaCheck className="text-green-500 mr-2" /></span>
                <span className="text-base text-left">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      }
    />
  </Card>
);

export default CategoryFeatureCard;
